import React, { useState, useEffect, useRef } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableFooter,
    TableContainer,
    TableHead,
    TableRow,
    Grid,
    TextField,
    withStyles,
    Select,
    MenuItem,
} from "@material-ui/core";
import Modal from '@mui/material/Modal';
import Box from "@mui/material/Box";
import moment from "moment";
import AddIcon from '@mui/icons-material/Add';
import Loader from '../../components//Loader2/index';
import { useHistory } from "react-router-dom";
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Autocomplete from "@material-ui/lab/Autocomplete";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { connect } from "react-redux";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ReplyAllIcon from "@mui/icons-material/ReplyAll";
import {
    getCenterInfo,
    getMrrSupportTickets,
    getExportedGrievance,
    updateMrrTicketStatus,
    getLabDetails,
    createClincialTicket,
} from "../../actions/OffLineSupportActions";
import CommentModal from "./CommetModal"
import CommentIcon from '@mui/icons-material/Comment';
import { generateGrievanceFilterUrl } from "../../healpers/generateUrl";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        buttonContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            marginTop: "50px",
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        modal: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "scroll",
        },
        paper: {
            marginTop: "2rem",
            padding: "0.5rem 2rem",
            width: "100%",
            overflow: "scroll",
            position: "sticky",
        },
        paper1: {
            backgroundColor: theme.palette.background.paper,
            border: "3px solid green",
            borderRadius: "5px",
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            width: "1200px",
        },
        table: {
            maxWidth: "100%",
            overflow: "scroll",
        },
        tableHead: {
            background: "rgb(146, 74, 145)!important",
        },
        imagePaper: {
            position: "absolute",
            backgroundColor: theme.palette.background.paper,
            border: "2px solid #000",
            boxShadow: theme.shadows[1],
        },
        rightContentHeader: {
            width: "30%",
            float: "right",
            textAlign: "right",
            paddingRight: "20px",
        },
        toolbar: {
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 1),
         
            ...theme.mixins.toolbar,
        },
        tableHeadCell: {
            color: "#fff",
            fontWeight: "bold",
            textAlign: "center",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
    })
);

const Input = styled("input")({
    display: "none",
});

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: "background.paper",
    border: "2px solid #59b023",
    boxShadow: 24,
    p: 4,
    BorderAllRounded: 2,
};

const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#0E3F6C",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);
function rand() {
    return Math.round(Math.random() * 20) - 10;
}
function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
interface Props {
    loading: boolean;
    getMrrSupportTickets: any;
    mrrSupportTicket: any;
    getCenterInfo: any;
    centerInfo: any;
    getExportedGrievance: any;
    updateMrrTicketStatus: any;
    getLabDetails:any;
    labDetails:any;
    createClincialTicket:any;
}

const RaiseTicket: React.FC<Props> = ({
    loading,
    getMrrSupportTickets,
    mrrSupportTicket,
    getCenterInfo,
    centerInfo,
    getExportedGrievance,
    updateMrrTicketStatus,
    getLabDetails,
    labDetails,
    createClincialTicket
}) => {
    const classes = useStyles();
    const history = useHistory();
    const [start_date, setStart_date] = useState<any>();
    const [status, setStatus] = useState<any>("");
    const [end_date, setEnd_date] = useState<any>("");
    const [center, setCentre] = useState<any>("");
    const [createdBy, setCreatedBy] = useState<any>("");
    const [openTicketModal, setOpenTicketModal] = useState<any>("");
    const [booking, setBooking] = useState<any>("");
    const [remarks, setRemarks] = useState<any>("");
    const [ticketId, setTicketId] = useState<any>("")
    const [centerCode, setCentreCode] = useState<any>("");
    const [labName, setLabName]  = useState<any>("");
    const [page, setPage] = useState<any>("");
    const [openTicketModal1, setOpenTicketModal1] = useState<any>("");
    const [bookingId, setBookingId] =  useState<any>("");
    const [value, setValue] = useState(0);
    const [raiseBookingId, setRaiseBookingId] = useState<any>("");
    const [raiseCategory, setRaiseCategory] = useState<any>("clinical_history");
    const [openRaiseTicketModal, setOpenRaiseTicketModal] = useState<any>(false);

    const timer = useRef<any>(0);



    useEffect(() => {
        if(value === 0){
            getMrrSupportTickets();
        }else if(value === 1){
            getMrrSupportTickets(`?category_name=clinical_history`);
        }
    }, [value]);


    useEffect(() => {
        getCenterInfo();
    },[])

    
    const handleDownload = async (url: string) => {
        try {
          const response = await fetch(url, {
            method: 'GET',
          });
      
          if (!response.ok) throw new Error('Download failed');
      
          const blob = await response.blob();
          const contentDisposition = response.headers.get('Content-Disposition');
      
         
          const fileNameMatch = contentDisposition?.match(/filename="?(.+)"?/);
          const fileName = fileNameMatch ? fileNameMatch[1] : 'clinical_history';
      
          const blobUrl = window.URL.createObjectURL(blob);
      
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = fileName; 
          document.body.appendChild(link);
          link.click();
          link.remove();
      
          window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
          console.error('Download failed:', err);
        }
      };
      

    const handleChangeStatus = () => {
        const body = {
            booking: booking,
            status: status,
        };
        updateMrrTicketStatus({ id: ticketId, data:body});
        getMrrSupportTickets();
        setOpenTicketModal(false);
    }

    const handleRaiseTicket = () => {
          const formData =  new FormData();
          formData.append("booking", raiseBookingId);
          formData.append("category_name", raiseCategory);
          formData.append("remarks", " ");

          createClincialTicket(formData);


    }


    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
      ) => {
        if (newPage > page) {
          let url = mrrSupportTicket.links && mrrSupportTicket.links.next.split("?")[1];
          getMrrSupportTickets(`?${url}`);
        } else if (newPage < page) {
          let url = mrrSupportTicket.links && mrrSupportTicket.links.previous.split("?")[1];
          getMrrSupportTickets(`?${url}`);
        }
        setPage(newPage as number);
      };


    const filterGrievance = () => {

        const body: any = {
            center: centerCode,
            labid: labName,
            bookingId: bookingId,
            start_date: start_date,
            end_date: end_date,
            status: status,
            lable: createdBy,
        };
        const url = generateGrievanceFilterUrl(body).substring(2);
        getMrrSupportTickets(`?${url}`);
        getExportedGrievance(`?${url}&export=true`);
       
    };

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
      };


    return (
        <>
            <div style={{ width: "100%", marginTop: "40px" }}>

                <Paper className={classes.paper} elevation={15}>
                    <Grid
                        container
                        spacing={1}
                        direction="row"
                        style={{ alignItems: "left", }}
                    >
                        <Grid item xs={12} sm={12} md={12}>
                        <Tabs
                    variant="fullWidth"
                    value={value}
                    onChange={handleChange}
                    aria-label="professional tabs"
                    sx={{
                        "& .MuiTab-root": {
                            fontSize: "25px",
                            fontWeight: "bold",
                            textTransform: "none",
                            padding: "12px 16px",
                            transition: "background 0.3s",
                            borderRadius: "5px",
                            backgroundColor: "#E5EDF1", 
                            color: "#1C4E80", 
                            "&:hover": {
                                backgroundColor: "B3C8CF",
                            },
                        },
                        "& .MuiTab-root.Mui-selected": {
                            backgroundColor: "rgb(28, 78, 128)",
                            color: "#fff",
                            borderRadius: "5px",
                            fontSize: "25px",
                            fontWeight: "bold",
                        },
                    }}
                >
                    <Tab label="MRR Support Tickets" {...a11yProps(0)} />
                    <Tab label="Clinical History Tickets" {...a11yProps(1)} />
                        </Tabs>
                        </Grid>
                    </Grid>
                    {
                        value === 0 ? (
                            <>
                            <Grid
                        container
                        spacing={1}
                        direction="row"
                        style={{ alignItems: "left", marginTop: "20px" }}
                    >
                        <Grid item xs={12} sm={4} md={3}>
                            <TextField
                                className="input"
                                name="name"
                                type="text"
                                label="Booking Id"
                                variant="outlined"
                                onChange={(e) => setBookingId(e.target.value as string)}
                                style={{ width: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <Autocomplete
                                id="center"
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                                        setCentre(obj?.id);
                                        setCentreCode(obj?.center_code);
                                    }
                                }}
                                freeSolo
                                blurOnSelect
                                options={centerInfo?.results || []}
                                disableCloseOnSelect
                                getOptionLabel={(option: any) =>
                                    (option?.display_name === null
                                        ? option?.name
                                        : option?.display_name) +
                                    "(" +
                                    option?.center_code +
                                    ")"
                                }
                                loading={loading}
                                onInputChange={(event, newInputValue) => {
                                    clearTimeout(timer.current);
                                    timer.current = setTimeout(() => {
                                        getCenterInfo(`?name_or_code=${newInputValue}`);
                                    }, 1000);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Centre/Code"
                                        variant="outlined"
                                        fullWidth
                                        className="input"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <Autocomplete
                                id="center"
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                                        setLabName(obj?.lab_credentials.id);
                                    }
                                }}
                                freeSolo
                                blurOnSelect
                                options={labDetails?.results || []}
                                disableCloseOnSelect
                                getOptionLabel={(option: any) =>
                                    ((option?.lab_credentials !== "" || option?.lab_credentials !== null)
                                        && option?.lab_credentials?.name) 

                                }
                                loading={loading}
                                onInputChange={(event, newInputValue) => {
                                    clearTimeout(timer.current);
                                    timer.current = setTimeout(() => {
                                        getLabDetails(`?name=${newInputValue}`);
                                    }, 1000);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Lab Name"
                                        variant="outlined"
                                        fullWidth
                                        className="input"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3}>
                            <TextField
                                className="input"
                                name="name"
                                type="date"
                                onWheel={(e: any) => e.target.blur()}
                                label="Start Date"
                                value={start_date}
                                variant="outlined"
                                onChange={(e) => setStart_date(e.target.value as string)}
                                style={{ width: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                className="input"
                                name="End Date"
                                type="date"
                                label="End Date"
                                value={end_date}
                                variant="outlined"
                                onChange={(e) => setEnd_date(e.target.value as string)}
                                style={{ width: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Select
                                variant="outlined"
                                fullWidth
                                value={status ? status : "none"}
                                style={{ height: "38px" }}
                                onChange={(e) => setStatus(e.target.value as string)}
                            >
                                <MenuItem value="none" disabled>
                                    Select Status
                                </MenuItem>
                                <MenuItem value="pending">Pending</MenuItem>
                                <MenuItem value="closed">Closed</MenuItem>

                            </Select>
                        </Grid>


                        <Grid item xs={12} sm={4} md={2}>
                            <Button
                                variant="contained"
                                color="secondary"
                                fullWidth
                                onClick={filterGrievance}
                            >
                                Filter
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => history.push("/dashboard/os/mrr-support-ticket")}
                            >
                                Reset
                            </Button>
                        </Grid>

                            </Grid>

                            <TableContainer
                        className={classes.tableContainer}
                        component={Paper}
                        style={{ maxHeight: "700px" }}
                    >
                        <Table stickyHeader aria-label="simple table">
                            <TableHead className={classes.tableHead}>
                                <StyledTableRow>
                                     <StyledTableCell className={classes.tableHeadCell}>
                                        Id
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={classes.tableHeadCell}>
                                        Booking Id
                                    </StyledTableCell>
                                    <StyledTableCell align="left">
                                        CC Name/Code
                                    </StyledTableCell>
                                    <StyledTableCell align="left">
                                        Lab Name
                                    </StyledTableCell>
                                    <StyledTableCell align="left" >
                                        Ticket Created By
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={classes.tableHeadCell}>
                                        Date & Time
                                    </StyledTableCell>
                                    <StyledTableCell  align="left" className={classes.tableHeadCell}>
                                        Category Type
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={classes.tableHeadCell}>
                                        Category Name
                                    </StyledTableCell>
                                    <StyledTableCell align="left" style={{ width:"30px"}}>
                                        Description
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={classes.tableHeadCell}>
                                        FRT date & time (30 Min)
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={classes.tableHeadCell}>
                                        Recent Update
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={classes.tableHeadCell}>
                                        Query Closed By
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={classes.tableHeadCell}>
                                        Ticket Closure Date & Time
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={classes.tableHeadCell}>
                                        Clinical History View
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={classes.tableHeadCell}>
                                        Status
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={classes.tableHeadCell}>
                                        Final Ticket Closure
                                    </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {mrrSupportTicket && mrrSupportTicket?.results?.length > 0 &&
                                    mrrSupportTicket?.results?.map((data: any) => {
                                        return (
                                            <StyledTableRow>
                                                <StyledTableCell align="center">
                                                    {data?.id}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.booking}
                                                </StyledTableCell>
                                                <StyledTableCell align="left">
                                                <label>{data?.center_details?.center_code}</label>
                                                <label>{data?.center_details?.center_name}</label>
                                                </StyledTableCell>
                                                <StyledTableCell align="left">
                                                   {data?.lab_details?.lab_name}
                                                </StyledTableCell>
                                                <StyledTableCell align="left" style={{ width:"30px"}}>
                                                    {data?.created_by_details.name}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                  {moment(data?.created_at).format('YYYY-MM-DD HH:mm')}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.category_type ? data?.category_type : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.category_name ? data?.category_name : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell align="left">
                                                    {data?.remarks}
                                                </StyledTableCell>
                                                <StyledTableCell align="left">
                                                    {data?.frt_date_time ? data?.frt_date_time : "-"}
                                                </StyledTableCell>
                                               
                                                <StyledTableCell align="center">
                                                <CommentIcon
                                                            style={{ color: "#0f636e" }}
                                                            onClick={() => {
                                                                setOpenTicketModal1(true);
                                                                setTicketId(data?.id);
                                                            }}
                                                        />
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.updated_by_details?.name}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data.updated_at ? moment(data?.updated_at).format('YYYY-MM-DD HH:mm') : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                <Button variant="contained" onClick={()=> handleDownload(data?.clinical_history)} disabled={data?.clinical_history === null}>Download</Button>
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.status}
                                                </StyledTableCell>

                                                {data?.status !== "closed" ? (
                                                    <StyledTableCell align="center">
                                                        <ReplyAllIcon
                                                            style={{ color: "#0f636e" }}
                                                            onClick={() => {
                                                                setOpenTicketModal(true);
                                                                setBooking(data?.booking);
                                                                setStatus(data?.status);
                                                                setTicketId(data?.id);
                                                            }}
                                                        />
                                                    </StyledTableCell>
                                                ) : (
                                                    <StyledTableCell align="center">
                                                        Ticket Closed
                                                    </StyledTableCell>
                                                )}
                                            </StyledTableRow>
                                        );
                                    })}
                            </TableBody>
                            <TableFooter>
                            <StyledTableRow>
                            <TablePagination
                              rowsPerPageOptions={[]}
                              colSpan={3}
                              count={mrrSupportTicket.count || 0}
                              rowsPerPage={mrrSupportTicket.page_size}
                              page={page}
                              onPageChange={handleChangePage}
                                />
                            </StyledTableRow>
                            </TableFooter>

                        </Table>
                            </TableContainer></>
                        ) : value === 1 ? (
                            <>
                            <Grid
                        container
                        spacing={1}
                        direction="row"
                        style={{ alignItems: "left", marginTop: "20px" }}
                    >
                       
                      
                       
                        

                        <Grid item xs={12} sm={12} md={12} style={{ display: "flex", justifyContent: "end" }}>
                            <Button
                                variant="contained"
                                color="secondary"
                                fullWidth
                                style={{ width: "auto" }}
                                onClick={() => setOpenRaiseTicketModal(true)}
                                startIcon={<AddIcon/>}
                                
                            >
                                Raise Ticket
                            </Button>
                        </Grid>

                       

                            </Grid>
                           

                            <TableContainer
                        className={classes.tableContainer}
                        component={Paper}
                        style={{ maxHeight: "700px" }}
                    >
                        <Table stickyHeader aria-label="simple table">
                            <TableHead className={classes.tableHead}>
                                <StyledTableRow>
                                     <StyledTableCell className={classes.tableHeadCell}>
                                        Id
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Booking Id
                                    </StyledTableCell>
                                    <StyledTableCell align="left">
                                        CC Name/Code
                                    </StyledTableCell>
                                    <StyledTableCell align="left">
                                        Lab Name
                                    </StyledTableCell>
                                    <StyledTableCell align="left" >
                                        Ticket Created By
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Date & Time
                                    </StyledTableCell>
                                    
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Category Name
                                    </StyledTableCell>
                                   
                                    
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Ticket Closure Date & Time
                                    </StyledTableCell>
                                    <StyledTableCell className={classes.tableHeadCell}>
                                        Clinical History View
                                    </StyledTableCell>
                                    
                                    
                                    
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {mrrSupportTicket && mrrSupportTicket?.results?.length > 0 &&
                                    mrrSupportTicket?.results?.map((data: any) => {
                                        return (
                                            <StyledTableRow>
                                                <StyledTableCell align="center">
                                                    {data?.id}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.booking}
                                                </StyledTableCell>
                                                <StyledTableCell align="left">
                                                <label>{data?.center_details?.center_code}</label>
                                                <label>{data?.center_details?.center_name}</label>
                                                </StyledTableCell>
                                                <StyledTableCell align="left">
                                                   {data?.lab_details?.lab_name}
                                                </StyledTableCell>
                                                <StyledTableCell align="left" style={{ width:"30px"}}>
                                                    {data?.created_by_details.name}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                  {moment(data?.created_at).format('YYYY-MM-DD HH:mm')}
                                                </StyledTableCell>
                                                
                                                <StyledTableCell align="center">
                                                    {data?.category_name ? data?.category_name : "-"}
                                                </StyledTableCell>
                                               
                                               
                                                
                                               
                                                <StyledTableCell align="center">
                                                    {data.updated_at ? moment(data?.updated_at).format('YYYY-MM-DD HH:mm') : "-"}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                   <Button variant="contained" onClick={()=> handleDownload(data?.clinical_history)} disabled={data?.clinical_history === null}>Download</Button>
                                                </StyledTableCell>
                                               

                                                
                                            </StyledTableRow>
                                        );
                                    })}
                            </TableBody>
                            <TableFooter>
                            <StyledTableRow>
                            <TablePagination
                              rowsPerPageOptions={[]}
                              colSpan={3}
                              count={mrrSupportTicket.count || 0}
                              rowsPerPage={mrrSupportTicket.page_size}
                              page={page}
                              onPageChange={handleChangePage}
                                />
                            </StyledTableRow>
                            </TableFooter>

                        </Table>
                            </TableContainer>
                            </>
                        ) : ""
                    } 

                </Paper>
                <Dialog
                    open={openTicketModal}
                    onClose={() => setOpenTicketModal(false)}
                    maxWidth="md"
                    sx={{ padding: "20px" }}

                >
                    <DialogTitle>MRR Ticket Status</DialogTitle>
                    <Grid container spacing={2} style={{ padding: "20px" }}>
                        <Grid item xs={12} sm={12} md={12}>
                            <Select
                                variant="outlined"
                                fullWidth
                                value={status ? status : "none"}
                                style={{ height: "38px" }}
                                onChange={(e) => setStatus(e.target.value as string)}
                            >
                                <MenuItem value="none" disabled>
                                    Select Status
                                </MenuItem>
                                <MenuItem value="pending">Pending</MenuItem>
                                <MenuItem value="closed">Closed</MenuItem>

                            </Select>
                        </Grid>
                        {/* <Grid item xs={12} sm={12} md={12}>
                            <TextField
                                className="input"
                                name="remarks "
                                type="text"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value as string)}
                                label="Remarks"
                                multiline
                                variant="outlined"
                                maxRows={10}
                                
                                style={{ width: "100%" }}
                            />
                        </Grid> */}
                    </Grid>


                    <DialogActions >
                        <Button onClick={() => setOpenTicketModal(false)} variant="outlined">Cancel</Button>
                        <Button variant="contained" onClick={handleChangeStatus}>Update</Button>
                    </DialogActions>
                </Dialog>
                <Modal
                    open={openRaiseTicketModal}
                    onClose={() => setOpenRaiseTicketModal(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        {
                            <Grid
                                container
                                spacing={2}
                                direction="row"
                                style={{ alignItems: "left" }}
                            >
                                <Grid item xs={12} sm={12} md={12}>
                                    <h4
                                        style={{
                                            fontWeight: "bold",
                                            color: "rgb(28, 78, 128)",
                                            textAlign: "center",
                                            padding: "10px",
                                            borderRadius: "15px",
                                        }}
                                    >
                                        Clinical History Ticket
                                    </h4>
                                </Grid>
                                
                                <Grid item xs={12} sm={12} md={12}>
                                    <p style={{ fontWeight: "bolder", fontSize: "15px", marginBottom: "8px" }}>Booking Id</p>
                                    <TextField
                                        className="input"
                                        name="raiseBookingId"
                                        type="number"
                                        placeholder="Enter Booking Id"
                                        value={raiseBookingId}
                                        variant="outlined"
                                        onChange={(e) => setRaiseBookingId(e.target.value)}
                                        style={{ width: "100%" }}
                                    />
                                </Grid>
                                 <Grid item xs={12} sm={12} md={12}>
                                    <p style={{ fontWeight: "bolder", fontSize: "15px", marginBottom: "8px" }}>Select Category</p>
                                    <Select
                                        className="input"
                                        name="raiseCategory"
                                        variant="outlined"
                                        value={raiseCategory}
                                        style={{ width: "100%", margin: "0", height: "40px" }}
                                        onChange={(e) => setRaiseCategory(e.target.value)}

                                    >
                                        <MenuItem value="clinical_history">Clinical History</MenuItem>
                                    </Select>
                                </Grid>
                                
                                
                               
                                <Grid item xs={12} sm={12} md={12}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                       
                                        onClick={handleRaiseTicket}
                                        disabled={raiseBookingId === "" }
                                    >
                                        Create Ticket
                                    </Button>
                                </Grid>
                            </Grid>
                        }
                    </Box>
                </Modal>
                {
                    openTicketModal1 && ticketId && (
                        <CommentModal openModal={openTicketModal1} setopenModal={setOpenTicketModal1} ticketId={ticketId} />
                    )
                }

            </div>
        </>
    );
};

const mapStateToProps = (state: any) => ({
    mrrSupportTicket: state.OffLineSupporteReducer.mrrSupportTicket,
    centerInfo: state.OffLineSupporteReducer.centerInfo,
    labDetails: state.OffLineSupporteReducer.labDetails,
    loading: state.OffLineSupporteReducer.loading,

});

export default connect(mapStateToProps, {
    getMrrSupportTickets,
    getCenterInfo,
    getExportedGrievance,
    updateMrrTicketStatus,
    getLabDetails,
    createClincialTicket
})(RaiseTicket);